import type { ColorScalesType } from "../types";
import * as dark from "./dark";
import * as light from "./light";

const ColorScales: ColorScalesType = { dark, light };

export default ColorScales;
